import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { videoPlayer } from 'vue-video-player';
import { getTempMaterialOther as _getTempMaterialOther, getMaterialOther as _getMaterialOther } from '@/api/wxmp/wxmaterial';
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
export default {
  name: "wxVideoPlayer",
  props: {
    objData: {
      type: Object
    },
    appId: {
      type: String
    }
  },
  components: {
    videoPlayer: videoPlayer
  },
  data: function data() {
    return {
      dialogVideo: false,
      outTime: false,
      mainLoading: false,
      playerOptions: {
        //        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false,
        //如果true,浏览器准备好时开始回放。
        muted: false,
        // 默认情况下将会消除任何音频。
        loop: false,
        // 导致视频一结束就重新开始。
        preload: 'auto',
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true,
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",
          src: "" //你的视频地址（必填）
        }],

        poster: "",
        //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试' //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //        controlBar: {
        //          timeDivider: true,
        //          durationDisplay: true,
        //          remainingTimeDisplay: false,
        //          fullscreenToggle: true  //全屏按钮
        //        }
      }
    };
  },
  created: function created() {
    this.outTime = this.objData.type === '1' && parseInt(new Date().getTime() - new Date(this.objData.createTime).getTime()) >= 259200000;
  },
  mounted: function mounted() {},
  computed: {},
  methods: {
    playVideo: function playVideo() {
      this.dialogVideo = true;
      this.getVideo();
    },
    getTempMaterialOther: function () {
      var _getTempMaterialOther2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(repMediaId, fileName) {
        var _this = this;
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.mainLoading = true;
              _context.next = 3;
              return _getTempMaterialOther({
                mediaId: repMediaId,
                fileName: fileName,
                appId: this.appId
              }).then(function (response) {
                _this.mainLoading = false;
                url = window.URL.createObjectURL(new Blob([response.data]));
              });
            case 3:
              return _context.abrupt("return", url);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTempMaterialOther(_x, _x2) {
        return _getTempMaterialOther2.apply(this, arguments);
      }
      return getTempMaterialOther;
    }(),
    getMaterialOther: function () {
      var _getMaterialOther2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(repMediaId, fileName) {
        var _this2 = this;
        var url;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.mainLoading = true;
              _context2.next = 3;
              return _getMaterialOther({
                mediaId: repMediaId,
                fileName: fileName,
                appId: this.appId
              }).then(function (response) {
                _this2.mainLoading = false;
                url = window.URL.createObjectURL(new Blob([response.data]));
              });
            case 3:
              return _context2.abrupt("return", url);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getMaterialOther(_x3, _x4) {
        return _getMaterialOther2.apply(this, arguments);
      }
      return getMaterialOther;
    }(),
    getVideo: function getVideo() {
      var _this3 = this;
      if (this.objData.type == '2') {
        this.$set(this.playerOptions.sources[0], 'src', this.objData.repUrl);
      } else if (this.objData.type == '1') {
        this.getTempMaterialOther(this.objData.repMediaId, this.objData.repMediaId + '.mp4').then(function (val) {
          _this3.$set(_this3.playerOptions.sources[0], 'src', val);
        });
      }
    },
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {}
  }
};